import axios from "axios";
import { clearUser } from "../../redux/actions/user.dispatcher";

export const BASE_URL = `${process.env.REACT_APP_PROD_BASE_URL}/api/`;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

export const getToken = async () => {
  try {
    const token = localStorage.getItem("token");

    return token;
  } catch (error) {
    console.error("Failed to retrieve the token from storage", error);
    return null;
  }
};

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let dispatch;

export const setFunctions = (dispatchFunction) => {
  dispatch = dispatchFunction;
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Don't redirect on 401 from 2FA endpoints — the user is on the
      // login page entering a TOTP / recovery code and hasn't received
      // a JWT yet.  A redirect would destroy the React component state
      // (userId, email, password) and force them to start over.
      const requestUrl = error.config?.url || "";
      const is2FAEndpoint = requestUrl.includes("/2fa/");

      if (!is2FAEndpoint) {
        if (dispatch) {
          dispatch(clearUser());
        }

        localStorage.removeItem("token");

        window.location = "/dashboard/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
